import { render, staticRenderFns } from "./pendingDocumentCard.vue?vue&type=template&id=e42836ae&scoped=true&"
import script from "./pendingDocumentCard.vue?vue&type=script&lang=js&"
export * from "./pendingDocumentCard.vue?vue&type=script&lang=js&"
import style0 from "./pendingDocumentCard.vue?vue&type=style&index=0&id=e42836ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42836ae",
  null
  
)

export default component.exports